import React, { useContext } from 'react'
import { IonRow, IonCol, IonButton, IonItem, IonIcon, IonLabel, isPlatform, IonList } from '@ionic/react'
import { AuthContext } from '../../contexts/AuthContext'
import { appLinks, appAdminLinks } from './QuickList'
import { calculator, cart, cube, settings, list, bookmarks, book, person, newspaper, wallet } from 'ionicons/icons'
import { APPLINKS } from '../../resources/AppConst'
const { signup, createInvoice, invoice, purchaseEntry, purchaseList, ledger, stocks, reports, expenses } = APPLINKS;

const QuickLinks = () => {

    const { User } = useContext(AuthContext)
    let menulist = User.isAdmin ? appAdminLinks : appLinks


    return isPlatform("mobile") ? (
        <IonList class='ion-align-self-start'>
            {
                menulist.map((link, i) => (
                    <IonButton expand='block' key={i} >
                        <IonItem color="primary" routerLink={link.url}>
                            <IonIcon slot='start' icon={link.icon} />
                            <IonLabel>{link.title}</IonLabel>
                        </IonItem>
                    </IonButton>
                ))
            }
        </IonList>
    ) : (<>
            <IonRow>
                <IonCol sizeMd='5.8'>
                    <IonButton expand='block'>
                        <IonItem color='primary' routerLink={createInvoice}>
                            <IonIcon slot='start' icon={calculator}></IonIcon>
                            <IonLabel>Create Invoice</IonLabel>
                        </IonItem>
                    </IonButton>
                    <IonButton expand='block'>
                        <IonItem color='primary' routerLink={purchaseEntry}>
                            <IonIcon slot='start' icon={cart}></IonIcon>
                            <IonLabel>Purchase Entry</IonLabel>
                        </IonItem>
                    </IonButton>
                    <IonButton expand='block'>
                        <IonItem color='primary' routerLink={stocks}>
                            <IonIcon slot='start' icon={cube}></IonIcon>
                            <IonLabel>Stock And Inventory</IonLabel>
                        </IonItem>
                    </IonButton>
                    <IonButton expand='block'>
                        <IonItem color='primary' routerLink={reports}>
                            <IonIcon slot='start' icon={newspaper}></IonIcon>
                            <IonLabel>Reports</IonLabel>
                        </IonItem>
                    </IonButton>
                    <IonButton expand='block'>
                        <IonItem color='primary' routerLink={APPLINKS.settings}>
                            <IonIcon slot='start' icon={settings}></IonIcon>
                            <IonLabel>Settings</IonLabel>
                        </IonItem>
                    </IonButton>
                </IonCol>
                <IonCol offsetMd='0.4' sizeMd='5.8' offsetSm='0' sizeSm='12'>
                    <IonButton expand='block'>
                        <IonItem color='primary' routerLink={invoice}>
                            <IonIcon slot='start' icon={list}></IonIcon>
                            <IonLabel>View & Search Invoices</IonLabel>
                        </IonItem>
                    </IonButton>
                    <IonButton expand='block'>
                        <IonItem color='primary' routerLink={purchaseList}>
                            <IonIcon slot='start' icon={bookmarks}></IonIcon>
                            <IonLabel>View Purchase List</IonLabel>
                        </IonItem>
                    </IonButton>
                    <IonButton expand='block'>
                        <IonItem color='primary' routerLink={ledger}>
                            <IonIcon slot='start' icon={book}></IonIcon>
                            <IonLabel>View account Ledger</IonLabel>
                        </IonItem>
                    </IonButton>
                    <IonButton expand='block'>
                        <IonItem color='primary' routerLink={expenses}>
                            <IonIcon slot='start' icon={wallet}></IonIcon>
                            <IonLabel>View Expenses</IonLabel>
                        </IonItem>
                    </IonButton>
                    <IonButton expand='block'>
                        <IonItem color='primary' routerLink={signup}>
                            <IonIcon slot='start' icon={person}></IonIcon>
                            <IonLabel>Register User</IonLabel>
                        </IonItem>
                    </IonButton>
                </IonCol>
            </IonRow>
        </>)
}

export default QuickLinks
